module.exports = __webpack_public_path__ + "static/img/c1.6e32787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/dam/c1.png
// module id = BQzt
// module chunks = 0